import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import Layout from '@/themes';
import Login from '@/pages/Login';
import Home from '@/pages/Home';
import DataReport from '@/pages/DataReport';
import PastData from '@/pages/PastData';
import TradeInReport from '@/pages/TradeInReport';
import OosEmailReport from '@/pages/OosEmailReport';
import OosScheduler from '@/pages/OosScheduler';

function Router() {
  return useRoutes([
    { path: '/login', element: <Login /> },
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        { index: true, element: <Home /> },
        { path: 'data-report', element: <DataReport /> },
        { path: 'past-data', element: <PastData /> },
        { path: 'trade-in-report', element: <TradeInReport /> },
        { path: 'oos-email-report', element: <OosEmailReport /> },
        { path: 'oos-scheduler', element: <OosScheduler /> },
      ],
    },
    { path: '*', element: <Navigate to="/" replace /> },
  ]);
}

export default Router;
